import { api } from '@/services'

function fetchReportTypes() {
  return api.get('/admin/financialReport/types')
}

function executeReport(type, date) {
  const params = { type }
  if (date) params.date = date
  return api.get('/admin/financialReport/execute', { params })
}

export { fetchReportTypes, executeReport }
